import styled from "@emotion/styled";
import { format, startOfDay, subDays, subMonths, subYears } from "date-fns";
import { FC } from "react";

import { IPickerListItem, Picker, SpacingToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

const today = startOfDay(new Date());

export const ALL_TIME_KEY = "all-time";

export const ticketImportTimeRangeOptions: IPickerListItem[] = [
  { key: format(subDays(today, 30)), name: "last 30 days" },
  { key: format(subDays(today, 90)), name: "last 90 days" },
  { key: format(subMonths(today, 6)), name: "last 6 months" },
  { key: format(subYears(today, 1)), name: "last year" },
  { key: format(subYears(today, 2)), name: "last 2 years" },
  { key: ALL_TIME_KEY, name: "all time" },
];

interface IProps {
  selectedDateRange: IPickerListItem | null;
  onDateRangeSelect: (dateRange: IPickerListItem) => void;
  disabled?: boolean;
}

export const ImportTicketsDateRangeSelect: FC<IProps> = ({
  selectedDateRange,
  onDateRangeSelect,
  disabled = false,
}) => (
  <Select
    options={ticketImportTimeRangeOptions}
    onSelect={timeRange => {
      if (timeRange) onDateRangeSelect(timeRange[0]);
    }}
    disabled={disabled}
    isRequired
    selected={selectedDateRange ? [selectedDateRange] : null}
    searchDisabled
    size="compact"
    placeholder="Select period"
  />
);

const Select = styled(Picker)`
  width: 128px;
  margin-right: ${withVar(SpacingToken.Spacing2)};

  button {
    padding-left: ${withVar(SpacingToken.Spacing2)};
    padding-right: ${withVar(SpacingToken.Spacing1)};
  }
`;
